import { useMemo } from 'react'

import { Grid, Skeleton } from '@mui/material'
import { useFormContext, useWatch } from 'react-hook-form'

import { ControlledAutocomplete } from 'components/common'
import { useGetDriverXeroCodesQuery, CreateAndUpdateDriverDtoInput } from 'generated/graphql'

const XeroPurchaseCodeSelector = () => {
  const {
    control,
    formState: { errors },
  } = useFormContext<CreateAndUpdateDriverDtoInput>()

  const watchedVatCategoryId = useWatch({
    control,
    name: 'vatCategoryId',
  })

  const { data: driverXeroCodesData, loading: driverXeroCodeLoading } = useGetDriverXeroCodesQuery()

  const driverXeroCodeOptions = useMemo(() => {
    if (!driverXeroCodeLoading && driverXeroCodesData?.driverXeroCodes) {
      const options = driverXeroCodesData?.driverXeroCodes.map((vc) => ({
        label: vc.xeroCode,
        value: vc.xeroCode,
        vatCategoryId: Number(vc.vatCategory?.id),
      }))

      return options
    }
    return []
  }, [driverXeroCodesData, driverXeroCodeLoading])

  // Filter options based on selected VAT category
  const filteredDriverXeroCodeOptions = useMemo(() => {
    if (!watchedVatCategoryId) return driverXeroCodeOptions

    return driverXeroCodeOptions.filter(
      (option) => String(option.vatCategoryId) === String(watchedVatCategoryId),
    )
  }, [driverXeroCodeOptions, watchedVatCategoryId])

  if (driverXeroCodeLoading) {
    return (
      <Grid item xs={12}>
        <Skeleton animation='wave' />
      </Grid>
    )
  }

  return (
    <Grid item xs={12}>
      <ControlledAutocomplete
        control={control}
        name='xeroPurchaseCode'
        label='Purchase Code'
        options={filteredDriverXeroCodeOptions}
        required
        error={!!errors.xeroPurchaseCode}
        helperText={errors.xeroPurchaseCode?.message}
      />
    </Grid>
  )
}

export default XeroPurchaseCodeSelector
